const MARKDOWN_PATH_REGEX = /\.md($|\?)/i;

export const hasMarkdownExtension = (value: string) => MARKDOWN_PATH_REGEX.test(value || '');

export const isMarkdownFile = (file: File) =>
  hasMarkdownExtension(file.name) || file.type.toLowerCase().includes('markdown');
